import { Component } from '@angular/core';

@Component({ templateUrl: './easel-shell.component.html' })
export class EaselShellComponent {}
